module.exports = __webpack_public_path__ + "2b2e8853b236fddc76d05fa19c8fe1da.MP3";